var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('v-icon',_vm._g(_vm._b({staticClass:"ml-1 mr-2",attrs:{"color":"secondary"},on:{"click":_vm.viewLegInfo}},'v-icon',attrs,false),on),[_vm._v(" mdi-eye ")])]}}])},[_c('span',[_vm._v("View")])]),_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [(
          _vm.params &&
          _vm.params.data &&
          [
            'Created',
            'Assigned',
            'Enroute',
            'Reached Pickup Location',
            'Reached Drop Location',
          ].indexOf(_vm.params.data.status) > -1
        )?_c('v-icon',_vm._g(_vm._b({staticClass:"ml-1 mr-1",attrs:{"color":"primary"},on:{"click":_vm.editLeg}},'v-icon',attrs,false),on),[_vm._v(" mdi-pencil ")]):_vm._e()]}}])},[_c('span',[_vm._v("Edit")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }